export interface UserInit {
  displayName: string;
  publicId: string;
  thumbnailUrl: {
    c120x120: string;
    p1280x1280: string;
    square: string;
    thumb: string;
  };
}

export default class User {
  public readonly displayName: string;
  public readonly publicId: string;
  public readonly thumbnailUrl: {
    c120x120: string;
    p1280x1280: string;
    square: string;
    thumb: string;
  };

  constructor(init: UserInit) {
    this.displayName = init.displayName;
    this.publicId = init.publicId;
    this.thumbnailUrl = init.thumbnailUrl;
  }
}

interface UserSnakeInit {
  display_name: string;
  public_id: string;
  thumbnail: {
    c120x120: { url: string };
    p1280x1280: { url: string };
    square: { url: string };
    thumb: { url: string };
  };
}

export function initializeFromSnake(init: UserSnakeInit): User {
  return new User({
    displayName: init.display_name,
    publicId: init.public_id,
    thumbnailUrl: {
      c120x120: init.thumbnail.c120x120.url,
      p1280x1280: init.thumbnail.p1280x1280.url,
      square: init.thumbnail.square.url,
      thumb: init.thumbnail.thumb.url,
    },
  });
}
